module.exports = __webpack_public_path__ + "media/components/assistant/images/icons/check-outline-60925e66fdee26ac1629b433bfb8753c.svg";